module.exports = __webpack_public_path__ + "img/infoGrey.5f730383.svg";